var _path, _g, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGloLogoWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5943_16548",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 6,
    width: 10,
    height: 11
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3647 11.3239C14.3647 13.9802 16.5258 16.1387 19.1822 16.1387C21.8393 16.1387 24.0001 13.9802 24.0001 11.3239C24.0001 8.66804 21.8393 6.50781 19.1822 6.50781C16.5258 6.50781 14.3647 8.66804 14.3647 11.3239Z",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5943_16548)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7939 10.3351L20.1712 3.93848L26.5704 12.3121L18.1931 18.7087L11.7939 10.3351Z",
    fill: "url(#paint0_linear_5943_16548)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1822 7.74482C17.208 7.74482 15.6015 9.35046 15.6015 11.3239C15.6015 13.2968 17.208 14.9024 19.1822 14.9024C21.1566 14.9024 22.763 13.2968 22.763 11.3239C22.763 9.35046 21.1566 7.74482 19.1822 7.74482ZM19.1822 16.1387C16.5258 16.1387 14.3647 13.9802 14.3647 11.3239C14.3647 8.66804 16.5258 6.50781 19.1822 6.50781C21.8393 6.50781 24.0001 8.66804 24.0001 11.3239C24.0001 13.9802 21.8393 16.1387 19.1822 16.1387Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8096 15.1692V0.666425C12.8096 0.298536 12.5118 0 12.1418 0C11.7742 0 11.4766 0.298536 11.4766 0.666425V15.1692C11.4766 15.5388 11.7742 15.8379 12.1418 15.8379C12.5118 15.8379 12.8096 15.5388 12.8096 15.1692Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8176 14.9034C2.84323 14.9034 1.23691 13.2979 1.23691 11.3248C1.23691 9.35144 2.84323 7.74604 4.8176 7.74604C6.7921 7.74604 8.3983 9.35144 8.3983 11.3248C8.3983 13.2979 6.7921 14.9034 4.8176 14.9034ZM9.63533 11.3245C9.63508 8.66902 7.47444 6.50879 4.8176 6.50879C2.16127 6.50879 0 8.66914 0 11.3248C0 13.9813 2.16127 16.1398 4.8176 16.1398C6.23928 16.1398 7.51494 15.5181 8.39768 14.5364V15.1839C8.39768 17.1574 6.79073 18.7631 4.81723 18.7631C4.47481 18.7631 4.19865 19.0403 4.19865 19.3813C4.19865 19.7236 4.47481 20.0001 4.81723 20.0001C7.47419 20.0001 9.63533 17.8398 9.63533 15.1839V11.3245Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5943_16548",
    x1: 17.054,
    y1: 12.9512,
    x2: 21.7391,
    y2: 9.37076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4823"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1473,
    stopColor: "#EE4F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#F06022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5986,
    stopColor: "#F37820"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8675,
    stopColor: "#F7951D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9975,
    stopColor: "#FAA61A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA61A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGloLogoWhite);
export default __webpack_public_path__ + "static/media/glo-logo-white.83295e0bc7a8f35fed02b0f8b4e67df7.svg";
export { ForwardRef as ReactComponent };